import React from 'react'
import PatientProfileLayout from 'presentation/patient/layouts/Profile'

export default function makePatientProfile() {
  return <PatientProfileLayout />
}
